module.exports = __webpack_public_path__ + "static/img/about-company-culture.e3aca09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-company-culture.png
// module id = 01JU
// module chunks = 1